import { Avatar, Grid, InputAdornment } from "@mui/material"
import AppDialog from "../../../components/Common/AppDialog"
import CustomTextField from "../../../components/Form/CustomTextField"
import { useEffect, useState } from "react"
import CustomSelectMultiple from "../../../components/Form/CustomSelectMultiple"
import CheckBox from "../../../components/Form/CheckBox"
import { getState } from "../../../store/actions"
import CustomAutocomplete from "../../../components/Form/CustomAutocomplete"

const AddShippingZoneModal = ({ open, close, submit, isEdit = false, initialData, error, countryList, stateList, dispatch }) => {
    const [formObj, setFormObj] = useState({});

    useEffect(() => {
        if (isEdit && initialData) {
            initialData?.country_id && dispatch(getState({ id: initialData.country_id }));
            setFormObj({
                ...initialData,
                offer_shipping_fee: initialData?.threshold && initialData?.threshold !== "0" ? true : false,
                threshold: initialData?.threshold && initialData?.threshold !== "-" ? initialData?.threshold : ""
            });
        }
        console.log("initialData", initialData)
        if(formObj && !initialData){
            setFormObj({});
        }
    }, [initialData])

    useEffect(() => {
        if (formObj?.country_id) {
            dispatch(getState({ id: formObj?.country_id }))
        }
    }, [formObj?.country_id])

    const handleFormObjChange = (key, value) => {
        let temp = { ...formObj };
        temp[key] = value;
        if(key === 'country_id'){
            temp['states'] = [];
        }
        if(key === 'offer_shipping_fee' && !value){
            temp['threshold'] = "";
        }
        setFormObj(temp);
    }

    const handleClose = () => {
        if (isEdit) {
            setFormObj({});
        }
        close();
    }
    
    return (
        <AppDialog
            open={open}
            title={`${isEdit ? "Edit" : "New"} shipping zone`}
            close={() => handleClose()}
            positiveTitle={isEdit ? 'Save changes' : 'Save'}
            positivePress={() => submit(formObj)}
            cancelButton={true}
            width={'60%'}
        >
            <Grid container spacing={2}>
                <Grid item sm={6} xs={12}>
                    <CustomTextField
                        title={'Zone Name'}
                        placeholder={'Zone Name'}
                        values={formObj.name}
                        onChange={(e) => handleFormObjChange('name', e)}
                        error={error?.name}
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <CustomAutocomplete
                        title={'Country'}
                        values={formObj.country_id || '-1'}
                        placeholder={'Select country'}
                        onChange={(e, value) => handleFormObjChange('country_id', value?.id)}
                        error={error?.country_id}
                        data={countryList || []}
                        labelName={'name'}
                        valueName={'id'}
                    />
                </Grid>
                <Grid item sm={12}>
                    <CustomSelectMultiple
                        title={'State Included'}
                        values={formObj.states || []}
                        onChange={(e) => handleFormObjChange('states', e)}
                        data={stateList || []}
                        labelName={'name'}
                        valueName={'id'}
                        multiple={true}
                        placeholder={'Select state'}
                        error={error?.states}
                    />
                </Grid>
                <Grid item sm={6}>
                    <CustomTextField
                        title={'Shipping Fee'}
                        values={formObj.fee}
                        onChange={(e) => handleFormObjChange('fee', e)}
                        placeholder="0"
                        type={'number'}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">RM</InputAdornment>,
                        }}
                        error={error?.shipping_fee}
                    />
                </Grid>
                <Grid item sm={6}></Grid>
                <Grid item sm={12}>
                    <CheckBox
                        label={'Offer free shipping when a customer buys over a certain amount'}
                        values={formObj?.offer_shipping_fee}
                        onChange={(e) => handleFormObjChange('offer_shipping_fee', e.target.checked)}
                    />
                    {
                        formObj?.offer_shipping_fee &&
                        <CustomTextField
                            values={formObj.threshold}
                            onChange={(e) => handleFormObjChange('threshold', e)}
                            placeholder="0"
                            type={'number'}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">RM</InputAdornment>,
                            }}
                            width={'50%'}
                            error={error?.free_shipping_threshold}
                        />
                    }
                </Grid>
            </Grid>
        </AppDialog>
    )
}
export default AddShippingZoneModal;